import { tv } from "@kirvanobr/theme";

export const styles = tv({
  slots: {
    base: [" px-0 data-[pressed=true]:bg-foreground-200 disabled:bg-transparent"],
    iconWrapper: [],
  },
  variants: {
    color: {
      primary: {
        iconWrapper: "text-primary-600",
      },
      secondary: {
        iconWrapper: "text-foreground-600",
      },
      tertiary: {
        iconWrapper: "text-foreground-600",
      },
      success: {
        iconWrapper: "text-success-600",
      },
      warning: {
        iconWrapper: "text-warning-600",
      },
      danger: {
        iconWrapper: "text-danger-600",
      },
    },
    isDisabled: {
      true: { base: "opacity-40" },
      false: {},
    },
  },
  defaultVariants: {
    color: "secondary",
    isDisabled: false,
  },
});
